import { CLEAR_USER_FEEDBACK } from './types'

const clearUserFeedback = () => ({ type: CLEAR_USER_FEEDBACK })

export { clearUserFeedback }
